// Store theme behaviour: option picker → variant, bundle savings, gallery, sticky buy bar.

(function () {
  var moneyFormat = '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var noDecimals = String(Math.round(cents / 100));
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  function initProductForm(form) {
    var section = form.closest('.hero') || document;
    var variantsEl = form.querySelector('[data-variants]');
    var input = form.querySelector('[data-variant-input]');
    var price = form.querySelector('[data-price]');
    var button = form.querySelector('[data-add-button]');
    var stickyPrice = section.querySelector('[data-sticky-price]');
    var stickyButton = section.querySelector('[data-sticky-button]');
    var fieldsets = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));
    if (!variantsEl || !input || !fieldsets.length) return;

    var variants = JSON.parse(variantsEl.textContent);
    var bundleSet = form.querySelector('[data-bundle-option]');
    var bundleIndex = bundleSet ? Number(bundleSet.dataset.optionIndex) : -1;

    function selected() {
      return fieldsets.map(function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });
    }

    function updateBundleCards(options) {
      if (!bundleSet) return;
      var radios = bundleSet.querySelectorAll('input');
      var single = null;
      radios.forEach(function (r) {
        if (Number(r.dataset.qty) === 1) {
          var o = options.slice(); o[bundleIndex] = r.value;
          single = findVariant(o) || single;
        }
      });
      radios.forEach(function (r) {
        var o = options.slice(); o[bundleIndex] = r.value;
        var v = findVariant(o);
        var label = r.closest('label');
        var priceEl = label.querySelector('[data-opt-price]');
        var savingEl = label.querySelector('[data-opt-saving]');
        var qty = Number(r.dataset.qty) || 1;
        r.disabled = !v || !v.available;
        if (priceEl) priceEl.textContent = v ? formatMoney(v.price) : '';
        if (savingEl) {
          var text = '';
          if (v && single && qty > 1) {
            var saving = single.price * qty - v.price;
            text = formatMoney(Math.round(v.price / qty)) + ' each';
            if (saving > 0) text = 'Save ' + formatMoney(saving) + ' · ' + text;
          }
          savingEl.textContent = text;
        }
      });
    }

    function sync() {
      var options = selected();
      updateBundleCards(options);
      var v = findVariant(options);
      var available = !!(v && v.available);
      if (v) input.value = v.id;
      if (price) price.textContent = v ? formatMoney(v.price) : 'Unavailable';
      if (stickyPrice && v) stickyPrice.textContent = formatMoney(v.price);
      if (button) {
        button.disabled = !available;
        button.textContent = available ? button.dataset.label : (v ? 'Sold out' : 'Unavailable');
      }
      if (stickyButton) stickyButton.disabled = !available;
      if (v && document.body.classList.contains('template-product')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
      if (v && v.featured_media) section.dispatchEvent(new CustomEvent('gallery:show', { detail: v.featured_media.id }));
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index] input')) sync();
    });
    sync();
  }

  function initGallery(gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var dots = gallery.querySelectorAll('[data-gallery-dot]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (slides.length < 2) return;

    function show(i) {
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    function mark(i) {
      dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      thumbs.forEach(function (t, j) {
        if (i === j) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        mark(Math.round(track.scrollLeft / track.clientWidth));
        ticking = false;
      });
    }, { passive: true });

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

    var hero = gallery.closest('.hero');
    if (hero) hero.addEventListener('gallery:show', function (e) {
      var i = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(e.detail); });
      if (i >= 0) show(i);
    });

    mark(0);
  }

  function initStickyBar(bar) {
    var hero = bar.closest('.hero');
    var main = hero && hero.querySelector('[data-add-button]');
    if (!main) return;
    // A scroll check rather than IntersectionObserver: jumps past the button
    // (anchor links, fast flicks) never cross the observer threshold.
    var shown = null;
    var ticking = false;
    function update() {
      ticking = false;
      var show = main.getBoundingClientRect().bottom < 0;
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelector('button').tabIndex = show ? 0 : -1;
      // keep the footer reachable above the bar
      document.documentElement.style.setProperty('--sticky-h', show ? bar.offsetHeight + 'px' : '0px');
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(root) {
    var fmt = root.querySelector('[data-money-format]') || document.querySelector('[data-money-format]');
    if (fmt) { try { moneyFormat = JSON.parse(fmt.textContent); } catch (e) {} }
    root.querySelectorAll('[data-product-form]').forEach(initProductForm);
    root.querySelectorAll('[data-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-sticky-buy]').forEach(initStickyBar);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
